import { defineMessages } from '@kyruus/intl';

export const messages = defineMessages({
  closeCtaDrawerAriaLabel: {
    id: 'cta_drawer.close.aria_label',
    description: 'Close drawer button',
    defaultMessage: 'Close booking options drawer'
  },
  ctaDrawerHeading: {
    id: 'cta_drawer.heading',
    description: 'Heading for CTA drawer',
    defaultMessage: 'Book with {providerName}'
  }
});
